import React, { Component } from 'react'
import CamaraSvg from '../../commons/images/CamaraSvg'

function Projupdates(props) {




  return (
    <React.Fragment>
      <div className="entry">
        <h3 className="heading-3">{props.heading}</h3>

        <div className="updateDescription">{props.desc}</div>

        <div className="updateImages">
          {props.itemImage
            ? props.itemImage.map((item, index) => {
                return (
                  <div className="itemImage" key={index}>
                    <a data-fancybox={props.gallery} href={item.fullimage}>
                      <img src={item.screenshot} alt="" />
                      {item.video ? <CamaraSvg /> : "" }
                    </a>
                  </div>
                );
              })
            : ""}
        </div>
      </div>
    </React.Fragment>
  );

}

export default Projupdates
